import React from 'react';
import InboxIcon from '../../Media/Sidebar/Inbox';
import LeadsIcon from '../../Media/Sidebar/Leads';
import CommunityIcon from '../../Media/Sidebar/Community';
import SettingsIcon from '../../Media/Sidebar/Settings';
import ChatbotSettings from '../../Media/Sidebar/ChatbotSettings';

export const SIDENAV_MENUS = {
  INBOX: {
    name: 'Inbox',
    logo: <InboxIcon />,
    route: '/',
    auth: ['ADMIN', 'AGENT'],
    access: ['/inbox', '/']
  },
  LEADS: {
    name: 'Leads',
    logo: <LeadsIcon />,
    route: '/leads',
    auth: ['ADMIN', 'AGENT'],
    permissions: 'leads',
    access: ['/leads']
  },
  COMMUNITIES: {
    name: 'Community',
    logo: <CommunityIcon />,
    route: '/communities',
    auth: ['ADMIN'],
    access: ['/communities', '/community', '/call-to-text']
  },
  SELF_SERVE: {
    name: 'Admin',
    logo: <SettingsIcon />,
    route: '/admin',
    auth: ['ADMIN'],
    access: ['/admin']
  }
};

// SUPER_ADMIN-only. `GlobalContextProvider` pushes this entry for that role
// alone, so its `access` list is effectively "paths only a SUPER_ADMIN may open".
//
// `/qa` rides along without a menu icon of its own (ZUM-3872), the same way
// `/call-to-text` rides on COMMUNITIES: the voice-call QA screen is reached one
// call at a time from Looker's Voice Call Audit explore, so it has no landing
// page to put in the sidebar. It still needs to be here — `Wrapper` matches the
// FIRST path segment against these lists and renders NoAccess for anything
// absent, so a route missing from `access` is unreachable no matter what
// `routesConfig` says.
export const SIDENAV_MENU_CHATBOT = {
  name: 'ChatbotSettings',
  logo: <ChatbotSettings />,
  route: '/chatbot-settings',
  auth: ['SUPER_ADMIN'],
  access: ['/chatbot-settings', '/qa']
};
